import {
  // * breakpoint-specific
  useSmallPhoneMediaQuery,
  useRegularPhoneMediaQuery,
  useTabletMediaQuery,
  useDesktopMediaQuery,
  useLargeDesktopMediaQuery,
  useExtraLargeDesktopMediaQuery,

  // * breakpoint and above
  usePhoneAndAboveMediaQuery,
  useTabletAndAboveMediaQuery,
  useDesktopAndAboveMediaQuery,
  useLargeDesktopAndAboveMediaQuery,

  // * breakpoint and below
  usePhoneAndBelowMediaQuery,
  useTabletAndBelowMediaQuery,
  useDesktopAndBelowMediaQuery,
  useLargeDesktopAndBelowMediaQuery,
} from "../../store/responsiveStore";

interface BreakpointProps {
  children: React.ReactNode;
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
  xxl?: boolean;
  only?: boolean;
  down?: boolean;
  up?: boolean;
}

const Breakpoint: React.FC<BreakpointProps> = (props) => {
  const { children, xs, sm, md, lg, xl, xxl, only, down, up } = props;
  // * breakpoint-specific
  if (xs && only) return <SmallPhoneOnly>{children}</SmallPhoneOnly>;
  if (sm && only) return <PhoneOnly>{children}</PhoneOnly>;
  if (md && only) return <TabletOnly>{children}</TabletOnly>;
  if (lg && only) return <DesktopOnly>{children}</DesktopOnly>;
  if (xl && only) return <LargeDesktopOnly>{children}</LargeDesktopOnly>;
  if (xxl && only)
    return <ExtraLargeDesktopOnly>{children}</ExtraLargeDesktopOnly>;

  // * breakpoint and above
  if (xs && up) return children;
  if (sm && up) return <PhoneAndAbove>{children}</PhoneAndAbove>;
  if (md && up) return <TabletAndAbove>{children}</TabletAndAbove>;
  if (lg && up) return <DesktopAndAbove>{children}</DesktopAndAbove>;
  if (xl && up) return <LargeDesktopAndAbove>{children}</LargeDesktopAndAbove>;
  if (xxl && up)
    return <ExtraLargeDesktopOnly>{children}</ExtraLargeDesktopOnly>;

  // * breakpoint and below
  if (xs && down) return <SmallPhoneOnly>{children}</SmallPhoneOnly>;
  if (sm && down) return <PhoneAndBelow>{children}</PhoneAndBelow>;
  if (md && down) return <TabletAndBelow>{children}</TabletAndBelow>;
  if (lg && down) return <DesktopAndBelow>{children}</DesktopAndBelow>;
  if (xl && down)
    return <LargeDesktopAndBelow>{children}</LargeDesktopAndBelow>;
  if (xxl && down) return children;

  return children;
};

interface GenericBreakpointProps {
  children: React.ReactNode;
}

// * Breakpoint and below
const PhoneAndBelow = (props: GenericBreakpointProps) => {
  const isPhoneAndBelow = usePhoneAndBelowMediaQuery();
  return isPhoneAndBelow ? props.children : null;
};
const TabletAndBelow = (props: GenericBreakpointProps) => {
  const isTabletAndBelow = useTabletAndBelowMediaQuery();
  return isTabletAndBelow ? props.children : null;
};
const DesktopAndBelow = (props: GenericBreakpointProps) => {
  const isDesktopAndBelow = useDesktopAndBelowMediaQuery();
  return isDesktopAndBelow ? props.children : null;
};
const LargeDesktopAndBelow = (props: GenericBreakpointProps) => {
  const isLargeDesktopAndBelow = useLargeDesktopAndBelowMediaQuery();
  return isLargeDesktopAndBelow ? props.children : null;
};

// * Breakpoint and above

const PhoneAndAbove = (props: GenericBreakpointProps) => {
  const isPhoneAndAbove = usePhoneAndAboveMediaQuery();
  return isPhoneAndAbove ? props.children : null;
};
const TabletAndAbove = (props: GenericBreakpointProps) => {
  const isTabletAndAbove = useTabletAndAboveMediaQuery();
  return isTabletAndAbove ? props.children : null;
};
const DesktopAndAbove = (props: GenericBreakpointProps) => {
  const isDesktopAndAbove = useDesktopAndAboveMediaQuery();
  return isDesktopAndAbove ? props.children : null;
};
const LargeDesktopAndAbove = (props: GenericBreakpointProps) => {
  const isLargeDesktopAndAbove = useLargeDesktopAndAboveMediaQuery();
  return isLargeDesktopAndAbove ? props.children : null;
};

// * Breakpoint-specific containers
const SmallPhoneOnly = (props: GenericBreakpointProps) => {
  const isSmallPhoneOnly = useSmallPhoneMediaQuery();
  return isSmallPhoneOnly ? props.children : null;
};
const PhoneOnly = (props: GenericBreakpointProps) => {
  const isPhoneOnly = useRegularPhoneMediaQuery();
  return isPhoneOnly ? props.children : null;
};
const TabletOnly = (props: GenericBreakpointProps) => {
  const isTabletOnly = useTabletMediaQuery();
  return isTabletOnly ? props.children : null;
};
const DesktopOnly = (props: GenericBreakpointProps) => {
  const isDesktopOnly = useDesktopMediaQuery();
  return isDesktopOnly ? props.children : null;
};
const LargeDesktopOnly = (props: GenericBreakpointProps) => {
  const isLargeDesktopOnly = useLargeDesktopMediaQuery();
  return isLargeDesktopOnly ? props.children : null;
};
const ExtraLargeDesktopOnly = (props: GenericBreakpointProps) => {
  const isExtraLargeDesktopOnly = useExtraLargeDesktopMediaQuery();
  return isExtraLargeDesktopOnly ? props.children : null;
};

export default Breakpoint;
